import React from 'react';
import { TooltipPosition } from '@progress/kendo-react-tooltip';
import cn from 'clsx';
import { Icon } from '../icon';

export interface IProps {
    title: string;
    dataTestId: string;
    className?: string;
    tooltipPosition?: TooltipPosition;
}

const ErrorIcon = ({ title, dataTestId, className, tooltipPosition }: IProps) => {
    return (
        <Icon
            dataTestId={dataTestId}
            className={cn('error-icon k-color-error k-cursor-help', className)}
            title={title}
            icon={['fal', 'circle-exclamation']}
            tooltipPosition={tooltipPosition}
            isError
        />
    );
};

export default ErrorIcon;
